import { Eye } from 'lucide-react'

interface VisitorBadgeProps {
  count?: number
  accessLevel: string
}

export function VisitorBadge({ count, accessLevel }: VisitorBadgeProps) {
  // Only show for platform-shared apps
  if (accessLevel !== 'platform') return null

  return (
    <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
      <Eye className="w-3 h-3" />
      {count && count > 0 ? `${count} visitors` : '--'}
    </span>
  )
}
